module.exports = __webpack_public_path__ + "img/BLS-token.d239ec8e.png";